import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import debounce from "lodash.debounce";
import visible from "../../assets/icons/visible 1.svg";
import download from "../../assets/icons/lucide_download.svg";
import btn3 from "../../assets/icons/analytic.svg";
import "../../assets/css/mainMenu.css";
import "../../assets/css/addunit.css";

import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import trash from "../../assets/icons/trash.svg";
import ArrowUp from "../../assets/icons2/ArrowUp.svg";
import plus1 from "../../assets/icons/plus1.svg";
import search2 from "../../assets/icons/search2.svg";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import { hasPermission } from "../../Services/authUtils";
const AssetGroupList = () => {
  const [viewData, setviewdata] = useState([]);
  const [viewmodal, setViewModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [assetGroupList, setAssetGroupList] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionAssetGroupId, setActionAssetGroupId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "created_at",
    order: "asc",
  });
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const navigate = useNavigate();
  const { id } = useParams();

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchAssetGroups(); // Perform search
    }
  };
  useEffect(() => {
    fetchAssetGroups();
  }, [
    id,
    page,
    pageSize,
    sortBy,
    //  search
  ]);

  const fetchAssetGroups = async () => {
    // setLoading(true);
    // const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}`;

    const queryString = `?page=${page}&limit=${pageSize}&order=${sortBy.order}&search=${search}`;
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-group/paginate${queryString}`;

    try {
      const data = await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate // Include navigate for handling unauthorized errors
      );

      setAssetGroupList(data.assetGroups);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);

    } catch (error) {
      console.error("Error fetching asset groups:", error);
      toast.error("Error fetching asset groups");
    } finally {
      setLoading(false);
    }
  };
  const downloadEquipment = async (assetId, name) => {
    setLoading(true);

    try {
      const response = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-groups/downloadAssetGroupJson/${assetId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        },
        navigate,
        true // Request the raw response
      );

      // Process the raw response as a blob
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `AssetGroup_${name}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
        setLoading(false);
      }
    }
  };
  const downloadyml = async (assetId, name) => {
    setLoading(true);
    try {
      // setLoading(true);
      const response = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-groups/downloadAssetGroupYml/${assetId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        },
        navigate,
        true // Request the raw response
      );

      // Process the raw response as a blob
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `AssetGroup_${name}.yml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
        setLoading(false);
      }
    }
  };
  const handleview = async (equipmentId) => {
    setLoading1(true);
    setViewModal(true);
    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-groups/preview/${equipmentId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}), // Add an empty body if required by your API
        },
        navigate
      );

      // Directly use the data received from fetchWrapper
      setviewdata(data.data || []);
      setLoading1(false);

    } catch (error) {
      console.error("Error fetching data:", error.message);
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
      }
    }
  };

  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearch(value);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const handleToggleUserStatus = (assetId) => {
    setActionAssetGroupId(assetId);
    setConfirmModal(true);
  };

  const confirmAction = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-group/delete/${actionAssetGroupId}`;



    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
        },
        navigate // Include navigate for handling unauthorized errors
      );

      toast.success("Asset Group Delete Successful");
      setConfirmModal(false);
      fetchAssetGroups();
    } catch (error) {
      console.error(`Error deleting asset group:`, error);
      toast.error(`Error deleting asset group: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setPage(page);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="">
        <div className="container">
          <div className="show-breadcrumb pt-3">
            <div className="">
              <h5>Asset Groups</h5>
              <nav className="breadcrumb-nav" aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a className="">Assets</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Asset Groups
                  </li>
                </ol>
              </nav>
              <div className="">
                <div
                  className="navbar-3 d-flex justify-content-between"
                  style={{ marginTop: "-3px" }}
                >
                  <div className="search-container ">
                    <img src={search2} alt="Search" />
                    <input
                      type="text"
                      className=""
                      id="search"
                      onChange={handleSearchChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Search "
                    />
                  </div>
                  {hasPermission(["assetGroup.create"]) && (
                    <div className="">
                      <button
                        type="button"
                        id="openPopup"
                        className="btn-bg"
                        onClick={() => navigate(`/add_asset_group`)}
                      >
                        <span className="plus-icon">
                          <img src={plus1} alt="Plus Icon" />
                        </span>
                        CREATE NEW ASSET GROUP
                      </button>
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "-10px" }}>
                  <div className="table-responsive">
                    <table className="table  align-middle table-text">
                      <thead className="table-head align-middle">
                        <tr>
                          <th style={{ width: "10rem" }}>ID</th>
                          <th
                            style={{ width: "20rem" }}
                            className="col  text-uppercase"
                            onClick={() => handleSortChange("asset_code")}
                          >
                            Asset Group Code{" "}
                            {sortBy.field === "asset_code" && (
                              <span>
                                {sortBy.order === "asc" ? (
                                  <img src={ArrowUp} alt="ArrowUp" />
                                ) : (
                                  <img src={ArrowDown} alt="ArrowDown" />
                                )}
                              </span>
                            )}
                          </th>
                          <th
                            style={{ width: "20rem" }}
                            className="col text-uppercase"
                            onClick={() => handleSortChange("asset_name")}
                          >
                            Asset Group Name{" "}
                            {sortBy.field === "asset_name" && (
                              <span>
                                {sortBy.order === "asc" ? (
                                  <img src={ArrowUp} alt="ArrowUp" />
                                ) : (
                                  <img src={ArrowDown} alt="ArrowDown" />
                                )}
                              </span>
                            )}
                          </th>

                          <th
                            style={{ width: "10rem" }}
                            className="col-2 text-uppercase"
                          >
                            ACTION
                          </th>
                        </tr>
                      </thead>
                      <tbody className="pl-4">
                        {assetGroupList.map((asset, id1) => (
                          <tr key={asset._id}>
                            <td>{id1 + startIndex}</td>
                            <td className="col">{asset.asset_group_code}</td>
                            <td className="col">{asset.asset_group_name}</td>

                            <td>
                              <div className="action-icons d-flex justify-content-left align-items-center ">
                                {hasPermission(["assetGroup.download"]) && (
                                  <button
                                    style={{
                                      border: "none",
                                      backgroundColor: "transparent",
                                    }}
                                    className="align-content-center me-3 mt-1"
                                    onClick={() =>
                                      downloadyml(
                                        asset._id,
                                        asset.asset_group_code
                                      )
                                    }
                                    title="Download YML file"
                                  >
                                    <img
                                      style={{ width: "25px" }}
                                      src={btn3}
                                      alt="Run Assessment"
                                    />
                                  </button>
                                )}
                                {hasPermission(["assetGroup.download"]) && (
                                  <button
                                    style={{
                                      border: "none",
                                      backgroundColor: "transparent",
                                    }}
                                    className="align-content-center me-3 mt-1"
                                    onClick={() =>
                                      downloadEquipment(
                                        asset._id,
                                        asset.asset_group_code
                                      )
                                    }
                                    title="Download JSON file"
                                  >
                                    <img
                                      style={{ width: "25px" }}
                                      src={download}
                                      alt="Download"
                                    />
                                  </button>
                                )}
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                  }}
                                  className="align-content-center me-3 mt-1"
                                  onClick={() => handleview(asset._id)}
                                  title="View"
                                >
                                  <img
                                    style={{ width: "25px" }}
                                    src={visible}
                                    alt="visible"
                                  />
                                </button>

                                {hasPermission(["assetGroup.update"]) && (
                                  <button
                                    style={{
                                      border: "none",
                                      backgroundColor: "transparent",
                                    }}
                                    className="align-content-center me-3"
                                    onClick={() =>
                                      navigate(`/edit_asset_group/${asset._id}`)
                                    }
                                    title="Edit"
                                  >
                                    <img src={edit} alt="edit" />
                                  </button>
                                )}
                                {hasPermission(["assetGroup.delete"]) && (
                                  <button
                                    style={{
                                      border: "none",
                                      backgroundColor: "transparent",
                                    }}
                                    className="align-content-center"
                                    onClick={() =>
                                      handleToggleUserStatus(asset._id)
                                    }
                                    title="Delete"
                                  >
                                    <img src={trash} alt="trash" />
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  pageSize={pageSize}
                  onPageSizeChange={handlePageSizeChange}
                  totalItems={totalItems}
                  startIndex={startIndex}
                  endIndex={endIndex}
                />
              </div>
            </div>
          </div>
          {/* Confirmation Modal */}
          <div
            id="overlay"
            className={`modal fade ${confirmModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: confirmModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>Delete Asset Group</h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setConfirmModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>
                <div className="addunit-form">
                  <p>Are you sure you want to delete this asset group?</p>
                </div>
                <div className="addunit-card-footer justify-content-between">
                  <button
                    type="button"
                    className="discard-btn"
                    onClick={() => setConfirmModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="update-btn"
                    onClick={confirmAction}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* View Modal Content */}
          <div
            id="overlay"
            className={`modal fade ${viewmodal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: viewmodal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading1 ? (
              <Loader />
            ) : (
              <div
                className="addunit-card"
                style={{
                  width: "50%",
                  height: "80%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="addunit-header">
                  <h4 className="modal-title">View Asset Group</h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setViewModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>
                <div
                  className="addunit-form"
                  style={{
                    flex: "1 1 auto",
                    overflowY: "auto",
                    marginBottom: "10px", // Adjust as needed for spacing
                  }}
                >
                  <pre>{JSON.stringify(viewData, null, 2)}</pre>
                </div>
                <div
                  className="addunit-card-footer justify-content-between"
                  style={{ flexShrink: 0 }}
                >
                  <button
                    type="button"
                    className="discard-btn"
                    onClick={() => setViewModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default AssetGroupList;
